import { Dates } from "src/modules/utils/shared/dates";
/* eslint-disable @typescript-eslint/no-inferrable-types */
import { Type } from 'class-transformer';
import { DateIntv } from 'src/modules/enaio/shared/DateIntv';
import { SmBaseEntity } from 'src/modules/sm-base/shared/sm-base-entity.model';
import { Column, Entity, ManyToOne } from 'typeorm';
import { ClassRegister } from './class-register.entity';

@Entity()
export class ClassHoliday extends SmBaseEntity {

    @ManyToOne(() => ClassRegister, (o: ClassRegister) => o.sickNotes, { onDelete: "CASCADE", nullable: false, orphanedRowAction: "delete"})
    classRegister: ClassRegister;

    @Column()
    @Type(() => Date)
    from: Date;

    @Column()
    @Type(() => Date)
    to: Date;

    @Column({default: ""})
    title: string = "";

    getDateIntv(): DateIntv {
        return new DateIntv(this.from, this.to);
    }

    getStringRepresentation(): string {
        return Dates.formatDefaultDate(this.from) + " - " + Dates.formatDefaultDate(this.to) + " - " + this.title;
    }
}